// 1 KB = 1024 bytes
// 1 MB = 1024 * 1024 bytes
// 500 MB = 500 * 1024 * 1024 bytes
export const MAX_UPPY_FILES_SIZES_LIMITS = {
  images:
    parseInt(process.env.NEXT_PUBLIC_UPPY_MAX_IMAGE_FILE_SIZE_MB || "10") *
    1024 *
    1024, // 10 MB
  videos:
    parseInt(process.env.NEXT_PUBLIC_UPPY_MAX_VIDEO_FILE_SIZE_MB || "600") *
    1024 *
    1024, // 600 MB
  pdf:
    parseInt(process.env.NEXT_PUBLIC_UPPY_MAX_PDF_FILE_SIZE_MB || "20") *
    1024 *
    1024, // 20 MB
  other:
    parseInt(process.env.NEXT_PUBLIC_UPPY_MAX_OTHER_FILE_SIZE_MB || "100") *
    1024 *
    1024, // 100 MB
};

// Helper function to determine file type category
export const getUppyFileTypeCategory = (contentType) => {
  if (contentType.startsWith("image/")) {
    return "images";
  }
  if (contentType.startsWith("video/")) {
    return "videos";
  }
  if (contentType === "application/pdf") {
    return "pdf"; // For files like Word, ZIP, etc.
  }
  return "other";
  // switch (contentType) {
  //   case contentType.startsWith("image/"):
  //     return "images";
  //   case contentType.startsWith("video/"):
  //     return "videos";
  //   case contentType === "application/pdf":
  //     return "pdf";
  //   default:
  //     return "other"; // For files like Word, ZIP, etc.
  // }
};
